// import infoArticleList from '../components/infoArticle/infoArticleList.vue'

export default [
    {
        path: 'infoArticle/infoArticleList',
        component: resolve => require(['@/components/infoArticle/infoArticleList'],resolve),
        name:"InfoArticleList",
        meta:{
            id:'881',
            node:'infoArticle',
            url:'infoArticleList',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/infoArticle.js